import { render, staticRenderFns } from "./youtube-categories-view.vue?vue&type=template&id=75658d24&"
import script from "./youtube-categories-view.vue?vue&type=script&lang=js&"
export * from "./youtube-categories-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports